/**
 * @file scan-focus.ts
 * @description Кому сейчас принадлежит фокус на складском экране (выделено из
 * `ScanField` в phase19.23).
 *
 * Поле скана возвращает себе фокус после каждой операции, но забирать его
 * из-под диалога, шторки или раскрытого меню нельзя: у них свой focus-trap,
 * и меню закрылось бы прямо под пальцем кладовщика.
 */

/** Слои с собственным focus-trap (`data-slot` компонентов ui/). */
const FOCUS_TRAP_SLOTS = [
  "dialog-content",
  "alert-dialog-content",
  "sheet-content",
  "dropdown-menu-content",
  "popover-content",
];

/** Открыт ли слой с собственным focus-trap. */
export function isFocusTrapOpen(): boolean {
  const selector = FOCUS_TRAP_SLOTS.map((slot) => `[data-slot="${slot}"]`).join(",");
  return document.querySelector(selector) !== null;
}
